<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2 4.714c0-.093.013-.186.053-.271A.66.66 0 0 1 2.667 4h6.667a.66.66 0 0 1 .614.443.742.742 0 0 1-.147.778l-3.334 3.57a.633.633 0 0 1-.94 0l-3.334-3.57A.746.746 0 0 1 2 4.714z"
        />
    </svg>
</template>
